(() => {
  function t() {
    for (let t of document.querySelectorAll("shopify-forms-embed")) {
      let e = document.createElement("style"); e.textContent = `
        :host {
          --teaser-color: ${document.documentElement.style.getPropertyValue("--teaser-color")};
          --teaser-background: ${document.documentElement.style.getPropertyValue("--teaser-background")};
          --teaser-close: ${document.documentElement.style.getPropertyValue("--teaser-close")};
        }

        button[data-testid="teaser-container"][data-testid="teaser-container"] {
          position: fixed;
          top: 50%;
          left: 0;
          transform-origin: top left;
          transform: translateY(100px) rotate(-90deg);
          padding: 4px 20px;
          background-color: #A92525;
          border-radius: 0;
          margin: 0;
          box-shadow: 0 0 10px 0 rgba(50,50,50,.75);
        }

        button[data-testid="teaser-container"] h3[data-testid="teaser-message"] {
          font-family: Lato, sans-serif;
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          color: white;
        }

        button[data-testid="teaser-container"] span[data-testid="btn-close"] > svg {
          fill: white;
        }
        #app-embed button[data-testid="teaser-container"] svg {
          fill: white;
          fill-opacity: 1;
        }

        ._appEmbedRootRotated_1tvcr_13 > div {
          position: fixed;
          top: 50%;
          left: 0;
        }

        button._teaserContainer_trejf_5 {
          border-radius: 0px !important;
          background-color: #A92525!important;
          box-shadow: 0 0 10px 0 rgba(50, 50, 50, .75)!important;
          width: max-content!important;
        }

        ._container_3eyaa_70 button._teaserContainer_trejf_5 {
          padding: 8px 20px;
        }

        ._teaserHeading_trejf_28 {
          font-size: 13px!important;
          font-weight: 600!important;
          letter-spacing: 0.04em;
          text-transform: uppercase;
          color: white!important;
        }

        ._formCloseButton_1684x_4 {
          justify-content: center;
          align-items: center;
          display: flex;
        }

        ._formCloseButton_1684x_4 > svg{
          fill: white !important;
          fill-opacity: 1!important;
        }

        .appEmbed._appEmbedRootTeaser_1tvcr_19._appEmbedLeftMiddleRotated_1tvcr_28 > div > button {
          margin: 0 !important;
        }

        ._formCloseButton_1684x_4._withBackground_1684x_15 {
          background: transparent!important;
        }

        ._formCloseButton_1684x_4._withBackground_1684x_15 > svg{
          fill: #000000 !important;
          fill-opacity: 0.65 !important;
        }
      `, t.shadowRoot.append(e), window.formEmbedModified = !0
    }
  } function e(e, o) { window.formEmbedModified ? o.disconnect() : t() } function o() { let t = new MutationObserver(e); t.observe(document.body, { childList: !0 }) } "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", o, { once: !0 }) : o()
})(), (() => { class t { constructor(t) { this.root = t, this.root.addEventListener("click", this.onClick.bind(this)) } onClick() { let t = this.root.textContent.trim(); navigator.clipboard.writeText(t).then(() => { alert(`${t} copied to clipboard`) }, t => { alert("Cannot copy to clipboard, please highlight and copy manually") }) } } function e() { for (let e of document.querySelectorAll("[data-click-to-copy]")) e.clickToCopy = new t(e) } window.ClickToCopy = t, "loading" === document.readyState ? document.addEventListener("DOMContentLoaded", e, { once: !0 }) : e() })();